import React from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { usePrompts, AiPrompt } from 'src/queries/useAiPrompts';

export interface AiPromptDropdownProps {
    value?: AiPrompt | null;
    onChange?: (prompt: AiPrompt | null) => void;
    placeholder?: string;
    isDisabled?: boolean;
    isClearable?: boolean;
    infoState?: 'error' | 'warning';
}

function AiPromptDropdown({
    value,
    onChange,
    placeholder = 'Select a prompt...',
    isDisabled = false,
    isClearable = true,
    infoState,
    ...props
}: AiPromptDropdownProps) {
    const { data: prompts = [], isLoading, error } = usePrompts();

    const options = prompts.map((prompt: AiPrompt) => ({
        value: prompt.promptId,
        label: prompt.promptName,
        data: prompt,
    }));

    const selectedOption = value
        ? options.find((option: { value: string; label: string; data: AiPrompt }) => option.value === value.promptId)
        : null;

    const handleChange = (selectedOption: any) => {
        if (onChange) {
            onChange(selectedOption ? selectedOption.data : null);
        }
    };

    if (error) {
        return (
            <div className={styles.error}>
                Error loading prompts: {error instanceof Error ? error.message : 'Unknown error'}
            </div>
        );
    }

    return (
        <Select
            className={classNames(styles.select, { [styles.error]: infoState === 'error' })}
            options={options}
            value={selectedOption}
            onChange={handleChange}
            placeholder={placeholder}
            isDisabled={isDisabled || isLoading}
            isLoading={isLoading}
            isClearable={isClearable}
            noOptionsMessage={() => 'No prompts available'}
            loadingMessage={() => 'Loading prompts...'}
            {...props}
        />
    );
}

export default AiPromptDropdown;
